import React, { useState } from 'react';
import { CasePlanSection } from '@orijinworks/frontend-commons';

export function EditableCasePlanSection({ initialDescription, ...sectionProps }) {
  const [description, setDescription] = useState(initialDescription ?? '');

  return (
    <CasePlanSection
      description={description}
      onDescriptionChange={setDescription}
      {...sectionProps}
    />
  );
}
